import React from 'react';
import styles from './index.module.scss';

export const Amd = () => <span className={styles.icon_amd}> </span>;
